export default __webpack_public_path__ + "static/media/Padron_3000Open.c8348fc6.jpg";